import gql from "graphql-tag";

export const CREATE_THREAD_ATTACHMENTS = gql`
  mutation createAttachments($data: [AttachmentInput!]!) {
    createAttachments(data: $data) {
      id
    }
  }
`;
